<script>
  import { currentPage } from "../stores/paging.js";
  export let id = "";
</script>


  {#if id === $currentPage}
    <article class="page">
      <slot />
    </article>
  {/if}


<style>
  .page {
    @apply fixed;
    @apply h-screen;
    @apply w-screen;
    @apply flex;
    @apply items-center;
    @apply justify-center;
  }
</style>